<template>
  <div class="w-full lg:w-1/2 mx-auto">
    <div class="bg-white border rounded-md shadow-sm p-8">
      <div class="flex items-center gap-10">
        <div>
          <i class="fa-light fa-earth-africa block !w-full !h-auto" />
        </div>

        <div>
          <h1 class="mb-4 lg:mb-6">
            <span class="block text-base">Error 404:</span>
            Page Not Found
          </h1>

          <p class="text-sm">
            We couldn’t find the page you are looking for. This could
            be due to a broken link, an outdated bookmark, or you
            may have typed the URL incorrectly.
          </p>

          <RouterLink
            :to="{ name: 'app_default' }"
            class="btn btn-solid btn-secondary"
          >
            <i class="fa-regular fa-arrow-left" />
            <span class="">Return Home</span>
          </RouterLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
</script>
